export const commonTranslations = {
  // 通用翻译
  "exploreBeautifulPenang": {
    en: "Explore Beautiful Penang",
    zh: "探索美丽的槟城"
  },
  "discoverMalaysia": {
    en: "Discover Malaysia's cultural paradise and find everything you need as a visitor, student, or new resident.",
    zh: "发现马来西亚的文化天堂，获取作为游客、学生或新居民所需的一切信息。"
  },
  "getStarted": {
    en: "Get Started",
    zh: "开始探索"
  },
  "searchPlaceholder": {
    en: "Search for services, guides, or information...",
    zh: "搜索服务、指南或信息..."
  },
  "searchButton": {
    en: "Search",
    zh: "搜索"
  },
  "learnMore": {
    en: "Learn More",
    zh: "了解更多"
  },
  "viewMore": {
    en: "View More",
    zh: "查看更多"
  },
  "contactUs": {
    en: "Contact Us",
    zh: "联系我们"
  },
  "visitWebsite": {
    en: "Visit Website",
    zh: "访问网站"
  },
  "email": {
    en: "Email",
    zh: "电子邮件"
  },
  "phone": {
    en: "Phone",
    zh: "电话"
  },
  "address": {
    en: "Address",
    zh: "地址"
  },
  "services": {
    en: "Services",
    zh: "服务"
  },
  "about": {
    en: "About",
    zh: "关于"
  },
  "features": {
    en: "Features",
    zh: "特点"
  },
  "more": {
    en: "More",
    zh: "更多"
  },
  "quickLinks": {
    en: "Quick Links",
    zh: "快速链接"
  },
  "socialMedia": {
    en: "Social Media",
    zh: "社交媒体"
  },
  "privacyPolicy": {
    en: "Privacy Policy",
    zh: "隐私政策"
  },
  "termsOfService": {
    en: "Terms of Service",
    zh: "服务条款"
  },
  "copyright": {
    en: "Copyright 2024 Penang Gateway. All rights reserved.",
    zh: "版权所有 2024 槟城门户。保留所有权利。"
  },
  "switchToChinese": {
    en: "中文",
    zh: "中文"
  },
  "switchToEnglish": {
    en: "English",
    zh: "English"
  },
  // Add new keys below
  "penangGatewayBrand": {
    en: "Penang Gateway",
    zh: "槟城门户"
  }
};
